module.exports = __webpack_public_path__ + "img/2.e3a1f983.jpg";